/**
 * Generates a random string. This is used to generate unique ids for different parts of the web components.
 * @param prefix - The prefix of the random string.
 * @param length - The length of the random string.
 * @param asLowerCase - Whether the random string should be in lower case.
 * @returns The random string.
 */
export function getRandomString(prefix, length, asLowerCase = true) {
    let result = `${prefix}-`;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return asLowerCase ? result.toString().toLowerCase() : result;
}
/**
 * Converts a camel case string to a kebab case string.
 * @param str - The camel case string to convert.
 * @returns The kebab case string.
 */
export const camelToKebabCase = (str) => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
export function toKebabCase(w) {
    return w.toLowerCase().split('_').join('-');
}
